<div class="card-wrapper border border-light rounded shadow-sm" style="height: 100%">
  <div class="card">
    <div class="card-body">
      <div class="head-tags">
        <button class="nav-button" (click)="previousMonth()" aria-label="calendar-btn-left">
          <svg class="icon" aria-label="Calendario bottone sinistro">
            <use href="bootstrap-italia/dist/svg/sprites.svg#it-chevron-left"></use>
          </svg>
        </button>
        <h3 class="card-title h3 text-capitalize mt-2">
          {{
          datePipe.transform(
          currentYear + "-" + (currentMonth + 1) + "-01",
          "MMMM y",
          "",
          "it"
          )
          }}
        </h3>
        <button class="nav-button" (click)="nextMonth()" aria-label="cal-btn-right">
          <svg class="icon" aria-label="Calendario bottone destro">
            <use href="bootstrap-italia/dist/svg/sprites.svg#it-chevron-right"></use>
          </svg>
        </button>
      </div>
      <div class="calendar-container">
        <div class="day day-header" *ngFor="let header of dayHeaders">
          {{ header }}
        </div>
        <div class="day empty-day" *ngFor="let emptyDay of [].constructor(firstDayOfMonth)"></div>
        <div class="day font-serif" *ngFor="let day of daysInMonth" (click)="onDateClick(day)">
          <span class="font-serif generic-day" [ngClass]="{ 'current-day': isCurrentDay(day) }">{{ day }}</span>
        </div>
      </div>
    </div>
  </div>
</div>